import React from 'react';

function InfoBoxText (props) {
	return (
		<div></div>
	);
}

export default InfoBoxText;